import { set, update } from '@/vuex/helpers';

export default {
  namespaced: true,
  state: {
    foreigner: null,
  },
  mutations: {
    set,
    update,
    add(state, [key, payload]) {
      state[key].push(payload);
    },

    remove(state, [key, toRemoveId]) {
      state[key] = state[key].filter(({ id }) => id !== toRemoveId);
    },
  },
  actions: {
    async load({ commit }, foreignerId) {
      const foreigner = await this.$axios.$get(`/api_foreigner/${foreignerId}/`);
      commit('set', ['foreigner', foreigner]);
    },
  },
};
